export default __webpack_public_path__ + "static/media/prize-1-bm.66e326a9.webp";